import { render } from "./VillageOverview.vue?vue&type=template&id=2e8806d1"
import script from "./VillageOverview.vue?vue&type=script&lang=js"
export * from "./VillageOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/VillageOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e8806d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e8806d1', __exports__)) {
    api.reload('2e8806d1', __exports__)
  }
  
  module.hot.accept("./VillageOverview.vue?vue&type=template&id=2e8806d1", () => {
    api.rerender('2e8806d1', render)
  })

}


export default __exports__